const playButton = document.querySelector('.process__play-button')
const video = document.querySelector('.process__video')
const player = video?.querySelector('video')
const iframe = video?.querySelector('iframe')

playButton?.addEventListener('click', () => {
    player?.setAttribute('controls', true)
    playButton.classList.add('process__play-button--hidden')
    if (player) {
        player.play()
    } else if (iframe) {
        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
    }
})
